// Exclusion list: List of templates that should not use this dispatch because backward compatibility is not yet assured
export const gabs = [
  "EMPTY_BANNER",
  "VIGNETTE_CROSS_SELL",
  "GAB_NAV_BAN_01",
  "GAB01_HB_ROP",
  "GAB01_HB_POKA",
  "GAB01_HB_OPTIN",
  "GAB01_HB_OPTIN_02",
  "GAB01_HB_POPIN",
  "GAB01_HB_KYC",
  "GAB_FP_01",
  "GAB_FP_PPI_01",
  "GAB01_CG_PROMO",
  "GAB02_CG_PROMO"
];
